const ITEMS = [
  "EAT MORE",
  "EXERCISE LESS",
  "RESET YOUR METABOLISM",
  "A HEALTHY BODY IS A RESPONSIVE BODY",
  "BACK TO YOU",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="bg-gradient-to-r from-[#4B2A9E] via-[#3A2DBF] to-[#1B2FD8] py-4 sm:py-6 overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-4xl text-[#FFFFFF]/90 px-6">
                  {item}
                </span>
                <span className="text-[#FFFFFF]/70 text-xl">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
